<template>
  <div class="recharge_left">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <h3>风控通知</h3>
      </div>
      <el-card class="box-card rishControl" shadow="hover" v-for="(item,index) in riskControl.data" :key="index">
        <h4>
          <!-- Dynamic Icons Based on Type -->
          <i class="el-icon-warning" style="color: orange;" v-if="item.type === 0"></i>
          <i class="el-icon-warning" style="color: #D02E27;" v-else-if="item.type === 1"></i>
          <i class="el-icon-warning" style="color: orange;" v-else-if="item.type === 2"></i>
          <i class="el-icon-bell" style="color: #D02E27;" v-else-if="item.type === 3"></i>
          <i class="el-icon-warning" style="color: #D02E27;" v-else-if="item.type === 4"></i>
          <i class="el-icon-warning" style="color: #D02E27;" v-else-if="item.type === 6"></i>
          <i class="el-icon-warning" style="color: orange;" v-else-if="item.type === 7"></i>
          <i class="el-icon-help" style="color: orange;" v-else></i>
          {{ item.time }}
        </h4>
        <p>{{ item.detail }}</p>
      </el-card>
      <div class="changePage">
        <el-button type="primary" class="button_blue_color"  icon="el-icon-arrow-left" size="mini" @click="prevRisk">上一页</el-button>
        <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" size="mini" @click="nextRisk" style="float: right">下一页</el-button>
      </div>   
    <div class="text_red_color"  style="margin-top: 25px; margin-bottom: 25px; color: red; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
      </el-card>

  </div>
</template>

<script>
    export default {
      name: "riskControl",
      data(){
        return{
        riskControl: {
            data: [],
            page: 1,
            num: 20
          }
        }
      },
      methods:{
        getRiskControl(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "risk_control",
              token: sessionStorage.getItem("token"),
              page:that.riskControl.page,
              num:that.riskControl.num
            }
          })
          .then(function (res) {
            let resData = res.data;
            if (resData.code === 1){
              that.riskControl.data = resData.data;
            }else if (resData.code === 0){
              that.$message.error(resData.msg);
            }
          })
        },
        updateRiskStatus(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "read_risk_control",
              token: sessionStorage.getItem("token"),
            }
          })
          .then(function (res) {
            let resData = res.data;
            if (resData.code === 1){
              that.$store.commit("clearRiskUnreadCount");
            }else if (resData.code === 0){
              that.$message.error(resData.msg);
            }
          })
        },
        prevRisk() {
          let page = this.riskControl.page;
          if (page == 1) {
            this.$message({
              message: '已经是第一页',
              type: 'warning'
            });
          } else {
            this.riskControl.page = page - 1;
            this.getRiskControl();
            this.scrollToTop();
          }
        },
        nextRisk() {
          let page = this.riskControl.page;
          if (this.riskControl.length < 20) {
            this.$message({
              message: '已经是最后一页',
              type: 'warning'
            });
          } else {
            this.riskControl.page = page + 1;
            this.getRiskControl();
            this.scrollToTop();
          }
        },
        scrollToTop() {
          window.scrollTo(0,0);
        }
      },
      mounted() {
        this.getRiskControl();
        this.updateRiskStatus();
      }
    }
</script>

<style scoped>
  .rishControl h4{
    font-size: 16px;
  }
  .rishControl p{
    font-size: 14px;
    color: black;
  }
  .changePage{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/riskControl.vue